import React, { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../../api";
import "../../styles/Login.scss";
import logo from "../../assets/images/safari-logo.svg";

const Login = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [remember, setRemember] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>("");

    const handleSubmit = async (
        event: FormEvent<HTMLFormElement>
    ) => {
        event.preventDefault();

        setLoading(true);
        setError("");

        try {
            const response = await api.post("/admin/login", {
                email,
                password,
                remember,
            });

            const { token, user } = response.data;

            if (!token) {
                throw new Error("No token returned from server");
            }

            if (remember) {
                localStorage.setItem("authToken", token);
                localStorage.setItem("userRole", user.role);
                localStorage.setItem("user", JSON.stringify(user));
            } else {
                sessionStorage.setItem("authToken", token);
                sessionStorage.setItem("userRole", user.role);
                sessionStorage.setItem("user", JSON.stringify(user));
            }

            api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

            navigate("/admin-dashboard");

        } catch (err: any) {
            console.error("Login failed:", err);

            setError(
                err.response?.data?.message ||
                err.message ||
                "Unable to log in. Please try again."
            );

        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-card">

                    <div className="login-header">
                        <img src={logo} alt="Safari Vinegar" />
                    </div>

                    <div className="login-content">

                        <p>Sign in to your account</p>

                        <form onSubmit={handleSubmit}>

                            <div className="form-group">
                                <label htmlFor="email">
                                    Email
                                </label>

                                <input
                                    id="email"
                                    type="email"
                                    value={email}
                                    onChange={(event) =>
                                        setEmail(event.target.value)
                                    }
                                    autoComplete="email"
                                    required
                                    disabled={loading}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="password">
                                    Password
                                </label>

                                <input
                                    id="password"
                                    type="password"
                                    value={password}
                                    onChange={(event) =>
                                        setPassword(event.target.value)
                                    }
                                    autoComplete="current-password"
                                    required
                                    disabled={loading}
                                />
                            </div>

                            <div className="login-options">

                                <label className="remember-me">
                                    <input
                                        type="checkbox"
                                        checked={remember}
                                        onChange={(event) =>
                                            setRemember(event.target.checked)
                                        }
                                        disabled={loading}
                                    />

                                    <span>Remember me</span>
                                </label>

                                <Link to="/forgot-password">
                                    Forgot password?
                                </Link>

                            </div>

                            {error && (
                                <div className="form-error">
                                    {error}
                                </div>
                            )}

                            <button
                                type="submit"
                                className="forgot-password-button"
                                disabled={loading}
                            >
                                {loading ? "Logging in..." : "Login"}
                            </button>

                        </form>

                    </div>

                </div>
            </div>
        </div>
    );
};

export default Login;
